import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { UseFormReturn } from "react-hook-form";
import type { Company, Industry } from "@/types/auth";

interface IndustrySelectProps {
  form: UseFormReturn<Company>;
  industries: Industry[];
  isSubmitting: boolean;
  apiError?: { detail?: { [key: string]: string[] } };
}

export function IndustrySelect({ form, industries, isSubmitting, apiError }: IndustrySelectProps) {
  return (
    <FormField
      control={form.control}
      name="industry"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Industry</FormLabel>
          <Select
            onValueChange={(value) => {
              field.onChange([parseInt(value, 10)]);
            }}
            value={field.value?.[0]?.toString()}
            disabled={isSubmitting}
          >
            <FormControl>
              <SelectTrigger className={apiError?.detail?.industry ? "border-red-500" : ""}>
                <SelectValue placeholder="Select industry" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {industries.map((industry) => (
                <SelectItem key={industry.id} value={industry.id.toString()}>
                  {industry.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}